// Centralized entity information for Jamilah N. Lawry / Nina Capone
// Used across profile page, structured data, author boxes, about sections

export const FOUNDER = {
  primaryName: "Jamilah N. Lawry",
  alternateName: "Jamilah Lawry",
  entertainmentName: "Nina Capone",
  jobTitles: [
    "Business Strategist",
    "Technology Consultant",
    "Media Entrepreneur",
    "Founder & Managing Consultant",
    "Author"
  ],
  organization: "My Biz Consulting LLC",
  profileUrl: "/jamilah-n-lawry",
  personId: "https://www.mybizconsulting.net/jamilah-n-lawry#person",
  profilePageId: "https://www.mybizconsulting.net/jamilah-n-lawry#profile",
  organizationId: "https://www.mybizconsulting.net/#organization",
  websiteId: "https://www.mybizconsulting.net/#website",
  domain: "https://www.mybizconsulting.net",
  bio: "Jamilah N. Lawry, professionally known in entertainment and media as Nina Capone, is a business strategist, technology consultant, media entrepreneur, and founder of My Biz Consulting LLC. Her work spans business operations, technology, artificial intelligence, digital media, and entrepreneurship.",
  shortBio: "Business strategist and founder of My Biz Consulting LLC, professionally known in entertainment and media as Nina Capone.",
  identityStatement: "Jamilah N. Lawry is professionally known in entertainment and media as Nina Capone.",
  founderStatement: "My Biz Consulting LLC was founded by business and technology strategist Jamilah N. Lawry, professionally known in entertainment and media as Nina Capone.",
  expertise: [
    "Business Strategy",
    "Business Operations",
    "Technology Consulting",
    "Artificial Intelligence Implementation",
    "Digital Transformation",
    "Entrepreneurship",
    "Digital Media",
    "Organizational Development"
  ],
  contact: {
    email: "Jamilah@mybizconsulting.net",
    phone: "215-443-1076",
    address: "304 Baltimore Avenue, Folcroft, PA 19032"
  },
  websites: {
    business: "https://www.mybizconsulting.net",
    entertainment: "https://ninacapone.com"
  },
  socialProfiles: {
    facebook: "https://www.facebook.com/MyBizConsulting",
    instagram: "https://www.instagram.com/mybizconsulting/",
    linkedin: "https://www.linkedin.com/company/my-biz-consulting-llc",
    twitter: "https://x.com/mybizconsult304",
    tiktok: "https://www.tiktok.com/@mybizconsulting",
    youtube: "https://www.youtube.com/channel/UC38WDYvX0Z2m9iEduQHytPA",
    pinterest: "https://www.pinterest.com/Mybizconsultingllc/",
  },
  certifications: [
    "Google Cloud & NVIDIA",
    "Apple Search Ads",
    "AI Marketing",
    "CompTIA",
    "Microsoft",
    "Project Management"
  ],
  awards: [
    { name: "Tech Behemoths Award 2025", url: "https://techbehemoths.com/awards-2025/wordpress/united-states#view=44749" },
    { name: "Influential Women Honoree", url: "https://influentialwomen.com/profile/jamilah-lawry" }
  ]
};

// JSON-LD Person entity
export const PERSON_JSONLD = {
  "@type": "Person",
  "@id": FOUNDER.personId,
  "name": FOUNDER.primaryName,
  "alternateName": [FOUNDER.alternateName, FOUNDER.entertainmentName],
  "jobTitle": FOUNDER.jobTitles[0],
  "description": FOUNDER.bio,
  "url": `${FOUNDER.domain}${FOUNDER.profileUrl}`,
  "sameAs": [
    FOUNDER.websites.entertainment,
    FOUNDER.socialProfiles.linkedin,
    FOUNDER.socialProfiles.facebook,
    FOUNDER.socialProfiles.instagram,
    FOUNDER.socialProfiles.twitter,
    FOUNDER.socialProfiles.youtube,
    FOUNDER.socialProfiles.tiktok,
    FOUNDER.socialProfiles.pinterest,
    FOUNDER.awards[0].url,
    FOUNDER.awards[1].url,
  ].filter(Boolean),
  "worksFor": {
    "@type": "Organization",
    "@id": FOUNDER.organizationId,
    "name": FOUNDER.organization
  },
  "knowsAbout": FOUNDER.expertise
};

// JSON-LD Organization entity
export const ORGANIZATION_JSONLD = {
  "@type": "Organization",
  "@id": FOUNDER.organizationId,
  "name": FOUNDER.organization,
  "alternateName": "My Biz Consulting",
  "url": FOUNDER.domain,
  "logo": `${FOUNDER.domain}/mybiz-logo.png`,
  "description": "AI-powered management consulting firm serving entrepreneurs, entertainers, and influencers. Specializing in systems integration, workflow optimization, AI-driven strategy, and operational excellence.",
  "founder": { "@type": "Person", "@id": FOUNDER.personId, "name": FOUNDER.primaryName },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "304 Baltimore Avenue",
    "addressLocality": "Folcroft",
    "addressRegion": "PA",
    "postalCode": "19032",
    "addressCountry": "US"
  },
  "telephone": "+1-215-443-1076",
  "email": "Jamilah@mybizconsulting.net",
  "sameAs": [
    FOUNDER.socialProfiles.facebook,
    FOUNDER.socialProfiles.linkedin,
    FOUNDER.socialProfiles.instagram,
    FOUNDER.socialProfiles.youtube,
  ].filter(Boolean)
};

// JSON-LD WebSite entity
export const WEBSITE_JSONLD = {
  "@type": "WebSite",
  "@id": FOUNDER.websiteId,
  "name": "My Biz Consulting",
  "url": FOUNDER.domain,
  "publisher": { "@type": "Organization", "@id": FOUNDER.organizationId }
};
